import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MinimalFooter from "./MinimalFooter";
import StickyUtilityBar from "./StickyUtilityBar";
import MobileStickyBar from "./MobileStickyBar";

export default function Layout({ children, hero = false, ribbon = false, minimal = false, hideFooter = false, minimalFooter = false, flushFooter = false }) {
  return (
    <div className="page-shell">
      {hero && (
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage:
              "linear-gradient(90deg, rgba(248,252,249,0.97) 0%, rgba(248,252,249,0.92) 45%, rgba(248,252,249,0.5) 100%), url(/energy-day-bg.png)",
            backgroundSize: "cover",
            backgroundPosition: "right center",
          }}
        />
      )}
      {hero && (
        <div
          className="absolute -left-[10%] -bottom-[24%] pointer-events-none"
          style={{ width: 560, height: 560, borderRadius: "50%" }}
        >
          <div className="w-full h-full glow-green opacity-70" />
        </div>
      )}
      {!minimal && <StickyUtilityBar />}
      {!minimal && <MobileStickyBar />}
      <div className="relative z-10">
        {!minimal && <Navbar ribbon={ribbon} />}
        <main>{children}</main>
        {!minimal && !hideFooter && (minimalFooter ? <MinimalFooter flush={flushFooter} /> : <Footer />)}
      </div>
    </div>
  );
}
